module.exports = __webpack_public_path__ + "static/media/rrss_6.92ceb977.png";